import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { MenuItem, Stack } from "@mui/material";
import { MouseEventHandler, ReactElement, ReactNode } from "react";
import { FaIcon } from "../../../DataDisplay/Icon/FaIcon";

export type SplitButtonMenuItemProps = {
  label: ReactNode;
  onClick: MouseEventHandler<HTMLLIElement>;
  selected: boolean;
  disabled?: boolean;
  startIcon?: ReactNode;
};

export const SplitButtonMenuItem = ({
  label,
  onClick,
  selected,
  disabled,
  startIcon,
}: SplitButtonMenuItemProps): ReactElement => {
  return (
    <MenuItem
      onClick={onClick}
      selected={selected}
      disabled={disabled}
      sx={{
        "&.Mui-selected, &.Mui-selected:hover": {
          backgroundColor: "fg.A200",
        },
      }}
    >
      <Stack
        direction="row"
        gap={2}
        alignItems="center"
        sx={{
          color: selected ? "fg.900" : "fg.700",
        }}
      >
        {startIcon}
        {label}
        <FaIcon
          icon={faCheck}
          sx={{
            visibility: selected ? "visible" : "hidden",
          }}
        />
      </Stack>
    </MenuItem>
  );
};
